// extracted by mini-css-extract-plugin
export var productImage = "_uu-0";